// Ancient Empires — character lore (server-safe). Generated by create-mod.
import data from './ancient-empires.data.json';

export const CHARACTER_LORE = data.lore;

export function getLoreById(id) {
  return CHARACTER_LORE[id] || null;
}
